













































































import {
    Vue,
    Component,
    Prop,
} from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import Icon from '@/components/Icon.vue';
import Spinner from '@/atomics/loaders/Spinner.vue';
import idealName from '@/utils/ideal-name';
import capitalize from '@/utils/text';
import { urlApi } from '@/utils/url';

interface DidInfo {
    did: string;
    queue_name: string;
}

@Component({ components: { Modal, Icon, Spinner } })
export default class ModalQueueDids extends Vue {
    @Prop(String) readonly name!: string;

    @Prop(Number) readonly customerId!: number;

    dids: string[] = [];

    isLoading = false;

    error = '';

    get queueDisplayName(): string {
        const queue = this.$store.getters.getQueueByName(this.name);
        return queue?.metadata?.name || capitalize(idealName(this.name));
    }

    openModal() {
        (this.$refs.modal as Modal).toogleModal();
        this.fetchDids();
    }

    closeModal() {
        (this.$refs.modal as Modal).toogleModal();
    }

    async fetchDids() {
        this.isLoading = true;
        this.error = '';
        this.dids = [];

        try {
            const url = `${urlApi}/queues/dids`;
            const token = sessionStorage.getItem('token') || '';

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    customerId: this.customerId,
                    queueNames: [idealName(this.name)],
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${JSON.stringify(data)}`);
            }

            // La respuesta puede venir en varios formatos:
            // 1. {"7001": ["3584181596"]} - objeto con queue name como key
            // 2. Array de objetos con { did, queue_name }
            // 3. { dids: [...] }
            const queueName = idealName(this.name);
            if (data[queueName] && Array.isArray(data[queueName])) {
                this.dids = data[queueName];
            } else if (Array.isArray(data)) {
                this.dids = data.map((item: DidInfo | string) => {
                    if (typeof item === 'string') return item;
                    return item.did;
                });
            } else if (data.dids) {
                this.dids = data.dids;
            }
        } catch (err) {
            this.error = `Error: ${(err as Error).message}`;
        } finally {
            this.isLoading = false;
        }
    }

    // eslint-disable-next-line class-methods-use-this
    formatDid(did: string): string {
        if (!did) return '';
        const cleaned = did.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        if (cleaned.length === 11 && cleaned.startsWith('1')) {
            return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
        }
        return did;
    }
}
